import { Button, Col, Form, Input, Row } from '@sinohealth/butterfly-ui-components/lib';
import React from 'react';

const SearchForm: React.FC = (props: any = {}) => {
  return (
    <Form labelAlign="right" colon={false} {...props}>
      <Row gutter={[120, 24]}>
        <Col span={6} style={{ paddingRight: 0 }}>
          <Form.Item name="name" label="产品名称：">
            <Input placeholder="请输入产品名称" />
          </Form.Item>
        </Col>
        <Col span={6} style={{ paddingRight: 0 }}>
          <Form.Item name="company" label="生产企业名称：">
            <Input placeholder="请输入生产企业名称" />
          </Form.Item>
        </Col>
        <Col span={6} style={{ paddingRight: 0 }}>
          <Form.Item name="approvalNumber" label="批准文号：">
            <Input placeholder="请输入批准文号" />
          </Form.Item>
        </Col>
        <Col span={6} style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              props.form.resetFields();
              props.form.submit();
            }}
          >
            重置
          </Button>
          &nbsp; &nbsp;
          <Button type="primary" htmlType="submit">
            查询
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchForm;
